<h2 mat-dialog-title>Confirm release application</h2>
<div mat-dialog-content class="mat-typography">
 <p>Are you sure you want to make the application available for the users now?</p>
</div>
<div mat-dialog-actions align="end">
  <button mat-button [mat-dialog-close]="true">YES, RELEASE</button>
  <button mat-button mat-dialog-close>CANCEL</button>
</div>
